import { Controller } from "@hotwired/stimulus";
import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";

const HOLIDAY_API = "https://holidays-jp.github.io/api/v1/date.json";

export default class extends Controller {
  static targets = ["calendar"];
  calendar = null;
  holidays = {};

  async connect() {
    document.addEventListener("turbo:load", () => {
      this.renderCalendar();
    });

    await this.loadHolidays();
    this.renderCalendar();
  }

  async loadHolidays() {
    try {
      const res = await fetch(HOLIDAY_API);
      this.holidays = await res.json();
    } catch (e) {
      console.error("祝日の取得に失敗しました", e);
      this.holidays = {};
    }
  }

  formatDateToLocalYYYYMMDD(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  renderCalendar() {
    const calendarElement = this.calendarTarget;
    if (!calendarElement) return;

    if (this.calendar) {
      this.calendar.destroy();
    }

    this.calendar = new Calendar(calendarElement, {
      plugins: [dayGridPlugin, interactionPlugin],
      initialView: "dayGridMonth",
      headerToolbar: {
        left: "title",
        center: "",
        right: "prev,next"
      },
      locale: "ja",
      height: "auto",

      // JSON 取得
      events: "/event_attendances/calendar_events.json",

      eventClick: (info) => {
        window.location.href = `/calendar_events/${info.event.id}`;
      },

      // 祝日表示
      dayCellDidMount: (arg) => {
        const dateStr = this.formatDateToLocalYYYYMMDD(arg.date);
        const holidayName = this.holidays[dateStr];

        if (holidayName) {
          const frame = arg.el.querySelector(".fc-daygrid-day-frame");
          if (!frame) return;
          frame.style.position = "relative";

          const holidayEl = document.createElement("div");
          holidayEl.textContent = "祝日";
          holidayEl.style.color = "red";
          holidayEl.style.fontSize = "0.65em";
          holidayEl.style.position = "absolute";
          holidayEl.style.left = "3px";
          holidayEl.style.bottom = "2px";

          frame.appendChild(holidayEl);
        }
      },

      // イベント描画時の色変更
      eventDidMount: (info) => {
        const status = info.event.extendedProps.status;
        const hasAttendance = info.event.extendedProps.has_attendance;
        const el = info.el;

        // 背景色
        el.style.backgroundColor = hasAttendance ? "#023893" : "#047fc75e";

        // 仮予定
        if (status === "仮予定") {
          el.style.opacity = "0.5";
        }

        // 表示要素
        const generationNames = info.event.extendedProps.generation;
        const titleEl = el.querySelector(".fc-event-title");
        const mainEl = el.querySelector(".fc-event-main");

        // タイトルのoverflow対策
        if (mainEl) {
          mainEl.style.whiteSpace = "nowrap";
          mainEl.style.overflow = "hidden";
          mainEl.style.textOverflow = "ellipsis";
        }

        if (titleEl) {
          titleEl.style.whiteSpace = "nowrap";
          titleEl.style.overflow = "hidden";
          titleEl.style.textOverflow = "ellipsis";
        }

        // 世代名の表示
        if (titleEl && generationNames) {
          const statusText = document.createElement("div");
          statusText.textContent = generationNames;
          statusText.style.fontSize = "0.75em";
          statusText.style.marginTop = "2px";
          statusText.style.textAlign = "center";
          statusText.style.color = hasAttendance ? "white" : "black";
          titleEl.parentNode.insertBefore(statusText, titleEl.nextSibling);
        }
      }
    });

    this.calendar.render();
  }
}
